import { APIFactory, factory } from './../api';

const ModuleName = 'RessieApp';

export class BookingAPI extends APIFactory {
  
  /* @ngInject */
  constructor(...args) {
    super(...args);
    this.actions = {
      'list': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/bookings/date/:date`
      },
      'update': {
        'method': 'PUT',
        'params': { 'id': '@_id' }
      },
      'cancel': {
        'method': 'PUT',
        'url': `${this.api.getDomain()}/booking/:id/cancel/:cancellation`,
        'params': { 'id': '@_id', 'cancellation': '@cancellation' }
      },
      'cancelAll': {
        'method': 'PUT',
        'url': `${this.api.getDomain()}/bookings/cancel/:day`,
        'params': { 'day': '@day' }
      },
      'bulkResend': {
        'method': 'POST',
        'url': `${this.api.getDomain()}/messages/resend`,
      },
      'receipt': {
        'method': 'POST',
        'url': `${this.api.getDomain()}/receipt/:id`,
        'params': { 'id': '@_id' }
      },
      'sms': {
        'method': 'POST',
        'url': `${this.api.getDomain()}/sms`,
      }

    };
  }

  get url() {
    return `${this.api.getDomain()}/booking/:id`;
  }

  setAction(name, obj) {
    this.actions[name] = obj;
  }

};

export default (function(){
  return factory('RessieApp', 'BookingAPI', BookingAPI);
})();


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/reservations/api.js